import React, { FC, memo } from "react";
import { Tooltip, IconTypesKeys } from "@evergis/ui";

import { TooltipIcon } from "./styled";

export const FeatureCardTooltip: FC<{ text: string; icon?: IconTypesKeys }> = memo(({ text, icon = "question" }) => {
  return text ? (
    <Tooltip placement={"top"} arrow content={text}>
      {ref => <TooltipIcon kind={icon} ref={ref} />}
    </Tooltip>
  ) : null;
});
